import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .quest {
    display: flex;

    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    width: 100%;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

    margin-top: 1rem;

    p {
      font-size: 1.2rem;
      color: #898989;
    }

    div {
      display: flex;
      gap: 1rem;
    }

    .img {
      width: 2.5rem;
      height: 2.5rem;

      color: #898989;
      background-color: rgba(188, 188, 188, 0.3);

      padding: 0.5rem;
      border-radius: 50%;

      cursor: pointer;
    }
    .checked {
      width: 2.5rem;
      height: 2.5rem;

      color: #898989;

      padding: 0.5rem;
      border-radius: 50%;

      cursor: pointer;
      background-color: rgba(43, 222, 83, 0.3);
    }
    .rejected {
      width: 2.5rem;
      height: 2.5rem;

      color: #898989;

      padding: 0.5rem;
      border-radius: 50%;

      cursor: pointer;
      background: rgba(239, 37, 37, 0.3);
    }
    #x {
      color: red;
      :hover {
        background: rgba(239, 37, 37, 0.3);
      }
    }
    #check {
      color: #2bde53;
      :hover {
        background: rgba(43, 222, 83, 0.3);
      }
    }
  }

  .sub-wrapper {
    display: flex;

    width: 100%;
  }

  .input-wrapper {
    display: flex;
    width: 100%;

    justify-content: space-around;
    margin-top: 1rem;

    label {
      display: flex;
      flex-direction: column;

      text-transform: uppercase;

      width: 100%;

      font-size: 1.2rem;
      gap: 1rem;

      textarea {
        font-size: 1.2rem;
        padding: 1rem;

        border: 1px solid #c4c4c4;

        max-width: 100%;
        max-height: 10rem;
        min-height: 6rem;
        min-width: 50%;
      }
    }
  }
`;
